import {
  Button,
  Card,
  Col,
  Collapse,
  Layout,
  Modal,
  Row,
  Select,
  Skeleton,
  Space,
  Tag,
  theme,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  changePositionInterprete,
  changeStatusInterprete,
  getInterpretesSearch,
  initPrestationSlice,
  setLoading,
  setPropertiesPrestation,
  setSelectedInterprete,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import CustomTable from "../../../shared/components/CustomTable";
import {
  formatCurrency,
  languagesList,
  renderUserGenderShort,
  renderUserName,
  roles,
  statusOption,
  statusPrestationsValues,
} from "../../../utils/constants";
import routes from "../../../engine/routes";
import {
  expandedRowRenderDetailInterpretes,
  prestationInterpretesColumns,
} from "./Prestation.interpretes.table";
import { TbUserSearch } from "react-icons/tb";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { isEqual } from "lodash";
import { askNewSearchInterpretesPrestation } from "../../../shared/components/Modals/modals";
import { keys } from "lodash/object";
import { PrestationInterpreteSelector } from "./Prestation.interprete.selector";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationInterpretes({ unitId, expanded, onClose, route }) {
  const isAdmin = userHasLevel({
    only: {
      [roles.admin]: "crud", //
      [roles.permanance]: "crud", //
    },
  });

  const { id } = useParams();

  const [needtoSave, setNeedToSave] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const { prestation, loading, interpretesHasSearch } = useSelector(
    state => state.prestation,
  );

  const getInterpretesSearchs = () => {
    setNeedToSave(true);
    dispatch(getInterpretesSearch(id));
  };

  const isCriteriaEqual = () => {
    let previousSearch = prestation?.searchInterpretes?.criteria || null;

    const criteriaSearch = {
      interpreteDataLanguages: prestation.language[0],
      infoGenre: prestation.search.searchGenre,
      interpreteDataInterpretingMode: prestation.intervention.type,
      interpreteDataInstitutionsToAvoid: prestation.institution._id.toString(),
      role: roles.interprete,
      status: "active",
      interpreteDataLevel: prestation.search.searchLevel,
    };

    return isEqual(criteriaSearch, previousSearch);
  };

  // useEffect(() => {
  //   if (prestation._id !== undefined &&  prestation?.searchInterpretes !== undefined) {
  //     if (isCriteriaEqual() === false) {
  //       askNewSearchInterpretesPrestation({
  //         onOk: getInterpretesSearchs,
  //         date: prestation?.searchInterpretes?.dateSearch,
  //       });
  //
  //       // Find differences
  //       // const changedKeys = keys(criteria).filter(
  //       //   key => !isEqual(criteria[key], previousSearch[key]),
  //       // );
  //       //
  //       // changedKeys.forEach(key => {
  //
  //       // });
  //     } else {
  //     }
  //
  //     // IF there is diff with loadh all key
  //   }
  // }, [prestation._id]);

  useEffect(() => {
    if (prestation._id !== undefined) {
      const criteria = {
        "interpreteData.languages": prestation.language[0],
        "info.genre": prestation.search.searchGenre,
        "interpreteData.interpretingMode": prestation.intervention.type,
        "interpreteData.institutionsToAvoid": prestation.institution._id.toString(),
        role: roles.interprete,
        status: "active",
        "interpreteData.level": prestation.search.searchLevel,
      };

      let previousSearch = prestation?.searchInterpretes?.criteria || null;

      if (previousSearch !== null) {
        if (!isEqual(criteria, previousSearch)) {
          askNewSearchInterpretesPrestation({
            onOk: getInterpretesSearchs,
            date: prestation?.searchInterpretes.dateSearch,
          });

          // Find differences
          // const changedKeys = keys(criteria).filter(
          //   key => !isEqual(criteria[key], previousSearch[key]),
          // );
          //
          // changedKeys.forEach(key => {

          // });
        } else {
        }

        // IF there is diff with loadh all key
      }
    }
  }, [prestation._id]);

  useEffect(() => {
    if (
      prestation.interpretesStatus.length === 0 &&
      interpretesHasSearch === false &&
      prestation._id !== undefined
    ) {
      getInterpretesSearchs();
    }
  }, []);

  const { init, clear } = initPrestationSlice({ id });

  const dispatch = useDispatch();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const { name, archived } = prestation;

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          name: "reference",
          required: true,
          disabled: true,
          capitalize: false,
          type: "input",
          value: prestation.reference,
          variant: "important",
          col: 12,
        },
      ],
    },
  ];

  const renderSearchChild = () => {
    return <div>Search</div>;
  };
  const saveInterpretesSearch = async () => {
    await dispatch(setLoading(true));
    let data = {};
    data.steps ??= {};

    data.steps.complements = true;

    setNeedToSave(false);

    await dispatch(setPropertiesPrestation(data));
    const result = await dispatch(updatePrestation());
    // the booking changed meanwhile: the page reloads instead of moving on
    if (result.payload?.stale) {
      return;
    }
    await navigate(routes.prestations(id).detailInformations.path);
    await dispatch(setLoading(false));
  };

  const sortingInterpretes = (a, b) => {
    // Define the sorting order for statuses
    const statusOrder = {
      selected: 1,
      invited: 2,
      relance: 3,
      refused: 4,
      not_invited: 5,
      not_available: 5,
      // Add other statuses here with their respective sort order
      // For example:
      // 'accepted': 2,
    };

    // Default to a high sort order if status is not recognized
    const aStatusOrder = statusOrder[a.status] || 99;
    const bStatusOrder = statusOrder[b.status] || 99;

    // First sort by status
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder;
    }

    // If statuses are the same, then sort by position
    if (a.position !== b.position) {
      return a.position - b.position;
    }

    // If positions are the same, then sort by cost
    return a.cost - b.cost;
  };

  // critere par qualifications et distance

  const renderResultsString = () => {
    return (
      <p>
        {!loading ? (
          <>
            {prestation.interpretesStatus.length > 0 && (
              <>
                <b>
                  {prestation.interpretesStatus.length} interprète
                  {prestation.interpretesStatus.length > 1 && "s"}
                </b>{" "}
                répondant à vos critères de recherches{" "}
                {prestation.interpretesStatus.length > 1 ? "sont" : "est"}{" "}
                disponibles
              </>
            )}

            {prestation.interpretesStatus.length === 0 &&
              "Aucun interprète correspond à vos critères de recherches"}
          </>
        ) : (
          <span className={"loadingdots"}>...</span>
        )}
      </p>
    );
  };

  const searchButton = () => (
    <Button
      disabled={prestation.status !== statusPrestationsValues.draft}
      type={"default"}
      size={"large"}
      onClick={getInterpretesSearchs}
      loading={loading}
      icon={<TbUserSearch size={20} />}
    >
      Rechercher un(e) interprète
    </Button>
  );

  const hasAtLeastOneInterprete = () => {
    let finder = prestation.interpretesStatus.some(e => {
      return (
        e.status === "selected" ||
        e.status === "invited" ||
        e.status === "relance"
      );
    });

    return finder;
  };

  return (
    <>
      <PrestationHeader
        title={routes.prestations(id).detailInterpretes.title}
      />

      {/*<Skeleton active title={"Hello"} paragraph={"hdhdhdhd"} />*/}

      <>
        <Space
          style={{
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {onlyRoleMapping([roles.admin, roles.permanance]) ? (
            renderResultsString()
          ) : (
            <p></p>
          )}
          {searchButton()}
        </Space>

        {/*<CustomForm*/}
        {/*  disabled={loading}*/}
        {/*  initialValues={prestation}*/}
        {/*  dataSource={inputs}*/}
        {/*  labelCol={24}*/}
        {/*  wrapperCol={24}*/}
        {/*/>*/}

        <br />

        <b>
          Pour maximiser vos chances de voir votre rendez-vous accepté, nous
          vous recommandons d’inviter plusieurs interprètes. La première
          personne acceptant l’invitation assurera la traduction. Vous recevrez
          un e-mail de confirmation dès que le rendez-vous sera validé.
        </b>

        <CustomTable
          emptyText={
            <>
              <p>Cliquer ici pour rechercher les interprètes disponible</p>
              {searchButton()}
            </>
          }
          loading={loading}
          smTitle={item => {
            return (
              <div className={"alignHeaderPage"}>
                <h2 className={"noMargin"}>{item.user}</h2>
              </div>
            );
          }}
          scroll={{ y: 1000, x: 1000 }}
          rowKey={i => i?.interprete?._id}
          columns={prestationInterpretesColumns(prestation, isAdmin)}
          customRowClassName={record => {
            return record.status === "refused" ||
              record.status === "not_invited" ||
              record.status === "not_available"
              ? "rowOpacity"
              : "";
          }}
          dataSource={prestation.interpretesStatus
            .filter(e => e.hidden === false)
            .filter(e => e.interprete !== null)
            .sort(sortingInterpretes)}
          expandable={
            onlyRoleMapping([roles.admin, roles.permanance])
              ? {
                  // expandRowByClick: true,
                  expandedRowRender: expandedRowRenderDetailInterpretes,
                  rowExpandable: record => record.name !== "Not Expandable",
                }
              : undefined
          }
        />

        <PrestationInterpreteSelector />

        <div style={{ textAlign: "right", paddingTop: 15 }}>
          <Button
            disabled={
              prestation.interpretesStatus.length === 0 ||
              (prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting) ||
              hasAtLeastOneInterprete() === false
            }
            loading={loading}
            onClick={saveInterpretesSearch}
            size={"middle"}
            type={"primary"}
          >
            Sauvegarder & suivant
          </Button>
        </div>
      </>
    </>
  );
}
